import * as yup from 'yup'

export const PHONE_REGEX = new RegExp(
  /^(\+?\d{1,4}[\s.-]?)?(\(?\d{1,5}\)?[\s.-]?)?[\d\s.-]{5,}$/,
)
// Password complexity policy: >= 12 chars, with at least one uppercase, one
// lowercase, one digit, and one non-alphanumeric character. Any special
// character is accepted (not a fixed whitelist). Kept in sync with the API's
// PASSWORD_REGEX (api/src/models/schemas/auth.schemas.ts) — the two repos are
// separate, so the pattern is intentionally duplicated and must be updated in
// both places. The backend is the authoritative check; this copy is for UX.
export const PASSWORD_REGEX = new RegExp(
  /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[^A-Za-z\d]).{12,}$/,
)

export const infoGlobalSchema = yup.object().shape({
  author: yup.string().required(),
  telAuthor: yup.string().required(),
  updateDate: yup.string().required(),
  informationText: yup.string().required(),
  secteurList: yup.array().of(
    yup.object().shape({
      name: yup.string().required(),
    }),
  ),
})

export const sectorFormSchema = yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
  acronym: yup.string().required(),
  kmStart: yup.number().required(),
  kmEnd: yup.number().required(),
})

export const teamFormSchema = yup.object().shape({
  name: yup.string().required(),
  acronym: yup.string().required(),
  color: yup.string().required(),
  isActive: yup.boolean().required(),
})

export const resourceFormSchema = yup.object().shape({
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  roleIds: yup.array().of(yup.string().required()).required().min(1),
  // phone and contact are optional (backend stores them nullable). Empty
  // strings are normalised to null. email is mandatory since v1.18.
  phone: yup
    .string()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value,
    )
    .optional(),
  contact: yup
    .string()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value,
    )
    .optional(),
  email: yup.string().email().required(),
  location: yup
    .string()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value,
    )
    .optional(),
  teamId: yup
    .string()
    .nullable()
    .transform((value, originalValue) =>
      originalValue === '' || originalValue === null ? null : value,
    )
    .optional(),
  isActive: yup.boolean().required(),
})

export const resourceRoleFormSchema = yup.object().shape({
  name: yup.string().required(),
  color: yup.string().required(),
  icon: yup.string().required(),
  isActive: yup.boolean().required(),
})

export const loginSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required(),
  rememberMe: yup.boolean().required(),
})

export const registerSchema = yup.object().shape({
  email: yup.string().email().required(),
  password: yup.string().required().matches(PASSWORD_REGEX).required(),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password')])
    .required()
    .matches(PASSWORD_REGEX)
    .required(),
  firstName: yup.string().required(),
  lastName: yup.string().required(),
  phone: yup.string().matches(PHONE_REGEX).required(),
  token: yup.string().required(),
})

export const passwordForgotSchema = yup.object().shape({
  email: yup.string().email().required(),
})

export const resetPasswordSchema = yup.object().shape({
  password: yup.string().required().matches(PASSWORD_REGEX).required(),
  passwordConfirmation: yup
    .string()
    .oneOf([yup.ref('password')])
    .required()
    .matches(PASSWORD_REGEX)
    .required(),
  token: yup.string().required(),
})

export const clientFormSchema = yup.object().shape({
  logo: yup.mixed<File>().optional(),
  name: yup.string().required(),
  email: yup.string().email().required(),
})
